"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError_bff = void 0;
var tslib_1 = require("tslib");
var index_1 = require("../../authorize/index");
var index_2 = require("../../common/index");
var index_3 = require("../index");
var index_4 = require("../../authorize/index");
var logError_bff = function (error) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var refererUrl, eventType, errorData, _err_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                refererUrl = (0, index_3.getRefererUrl)();
                eventType = error.errorMessage === 'Order Placed successfully' ? 'SUCCESS' : 'FAILURE';
                eventType = error.nrEventType ? error.nrEventType : eventType;
                errorData = {
                    input: {
                        fields: tslib_1.__assign(tslib_1.__assign({}, error), { applicationKey: index_1.authorizeParams.apiKey, refererUrl: refererUrl, endgameExperimentAllocation: index_4.endgameExperimentAllocation }),
                        eventType: eventType,
                    },
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, index_2.sendBFFCall)('logFECheckoutEvent', errorData)];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                _err_1 = _a.sent();
                /* istanbul ignore next */
                return [2 /*return*/]; // shouldn't throw an error, what will they do, log it?  ;)
            case 4: return [2 /*return*/, true];
        }
    });
}); };
exports.logError_bff = logError_bff;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/newRelic/bff/index.js
// module id = 3378
// module chunks = 11